<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue'
// @ts-ignore
import { Loader } from '@googlemaps/js-api-loader'
import type { Props } from './types'

const props = defineProps<Props>()
const { public: { googleApiKey } } = useRuntimeConfig()

const mapApiKey = props.apiKey || googleApiKey
const map = ref()
const marker = ref()
const loader = ref()
const markerIcon = props.markerIcon || 'https://lahaus.imgix.net/static/project_lunch_platform/map_icons/location_marker.png'
onMounted(() => {
  loader.value = new Loader({
    apiKey: mapApiKey,
    version: 'weekly'
  })

  loader.value.load().then(() => {
    // @ts-ignore
    map.value = new google.maps.Map(document.getElementById(props.id), {
      center: { lat: props.lat, lng: props.lng },
      zoom: 15,
      mapTypeControl: props.showMapTypeControl,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
        // @ts-ignore
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    })

    // @ts-ignore
    marker.value = new google.maps.Marker({
      position: { lat: props.lat, lng: props.lng },
      map: map.value,
      icon: markerIcon
    })
  })
})

onUnmounted(() => {
  if (loader.value) {
    loader.value = null
  }
})
</script>

<script lang="ts">
export default {
  name: 'AppMapDynamic'
}
</script>

<template>
  <div
    :id="id"
    :class="styles" />
</template>
